declare const loadChatWidget: (() => void) | undefined;

const CHAT_BUTTON_SELECTORS = '.embeddedMessagingConversationButton, .helpButtonEnabled';
const POLL_INTERVAL_MS = 500;
const MAX_WAIT_MS = 10000;

function clickChatButton(): boolean {
  const btn = document.querySelector<HTMLElement>(CHAT_BUTTON_SELECTORS);
  if (btn) {
    btn.click();
    return true;
  }
  return false;
}

function waitForChatButton(): void {
  let elapsed = 0;
  const interval = setInterval(() => {
    elapsed += POLL_INTERVAL_MS;
    if (clickChatButton() || elapsed >= MAX_WAIT_MS) {
      clearInterval(interval);
      if (elapsed >= MAX_WAIT_MS && BFG.supportWebformUrl) {
        window.open(BFG.supportWebformUrl, '_blank');
      }
    }
  }, POLL_INTERVAL_MS);
}

export function openLiveChat(): void {
  if (!window.BF_ENABLE_LIVECHAT) {
    if (BFG.supportWebformUrl) {
      window.open(BFG.supportWebformUrl, '_blank');
    }
    return;
  }

  if (clickChatButton()) {
    return;
  }

  if (typeof loadChatWidget === 'function') {
    loadChatWidget();
  }

  waitForChatButton();
}
